'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function YEFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-b5hqatvx3", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-4xuipg2zz", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-uiq01q7kv" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-uiq01q7kv", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-b5hqatvx3)" }, /* @__PURE__ */ React.createElement("use", { fill: "#f7fcff", xlinkHref: "#mantine-uiq01q7kv" }), /* @__PURE__ */ React.createElement("path", { fill: "#e31d1c", d: "M0 0h32v8H0z", mask: "url(#mantine-4xuipg2zz)" }), /* @__PURE__ */ React.createElement("path", { fill: "#272727", d: "M0 16h32v8H0z", mask: "url(#mantine-4xuipg2zz)" })))
  );
}

export { YEFlag };
//# sourceMappingURL=YE.mjs.map
